define('pwa/plugin/tickets/view/TicketsListView',['require','marionette','pwa/plugin/tickets/view/TicketsItemView'],function (require) {

    var Marionette = require('marionette');
    var TicketsItemView = require('pwa/plugin/tickets/view/TicketsItemView');

    /**
     * Client tickets list
     *
     * @class TicketsListView
     */
    return Marionette.CollectionView.extend({

        childView: TicketsItemView,
        collectionEvents: {
            'sync': 'render'
        },

    });

});
